webpackJsonp([208176855801404],{

/***/ 63:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"banner":"src-components-Banner----banner-module---banner---31KmZ src-styles----utils---shadowLvl1---1bhdJ"};

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bannerModule = __webpack_require__(63);
	
	var _bannerModule2 = _interopRequireDefault(_bannerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_React$Component) {
	  _inherits(Banner, _React$Component);
	
	  function Banner() {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Banner.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _bannerModule2.default.banner },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        this.props.children
	      )
	    );
	  };
	
	  return Banner;
	}(_react2.default.Component);
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jennifer.e9331021.jpg";

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/keva-after.ef53a547.jpg";

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sierra.4690cffa.jpg";

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(39);
	
	__webpack_require__(40);
	
	var _Banner = __webpack_require__(56);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Button = __webpack_require__(23);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Content = __webpack_require__(57);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Client = __webpack_require__(27);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Form = __webpack_require__(29);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _HalfHero = __webpack_require__(30);
	
	var _HalfHero2 = _interopRequireDefault(_HalfHero);
	
	var _Header = __webpack_require__(31);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Hero = __webpack_require__(32);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _IconList = __webpack_require__(33);
	
	var _IconList2 = _interopRequireDefault(_IconList);
	
	var _Testimonial = __webpack_require__(34);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	var _Testimonials = __webpack_require__(35);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _kevaAfter = __webpack_require__(156);
	
	var _kevaAfter2 = _interopRequireDefault(_kevaAfter);
	
	var _sierra = __webpack_require__(608);
	
	var _sierra2 = _interopRequireDefault(_sierra);
	
	var _jennifer = __webpack_require__(607);
	
	var _jennifer2 = _interopRequireDefault(_jennifer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Banner2.default,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Client Testimonials"
	      )
	    ),
	    _react2.default.createElement(
	      _Content2.default,
	      null,
	      _react2.default.createElement(
	        _Client2.default,
	        {
	          name: 'Keva S.',
	          image: _kevaAfter2.default,
	          id: 'keva' },
	        _react2.default.createElement(
	          "p",
	          null,
	          "I met Jerron November 11, 2016. I remember this day because I had less than 8 months to meet the fitness standards my job requires or be fired. I am 5\u20196, weighed 250 pounds and measured at 46% body fat. I admit I was skeptical, but also desperate, so I gave him a shot. Best decision I could have made! I am happy to report that 20 days before I was to be terminated, I weighed in at 191 lbs and 34% body fat. I am still happily employed and no longer worry how I\u2019m going to support my family without a job. November 11, 2017 I weighed in at 187 pounds, 32% body fat and the gains keep coming! If you need a trainer or are just curious, go with Jerron you won\u2019t be sorry."
	        )
	      ),
	      _react2.default.createElement(
	        _Client2.default,
	        {
	          name: 'Jennifer T.',
	          image: _jennifer2.default,
	          id: 'jennifer' },
	        _react2.default.createElement(
	          "p",
	          null,
	          "The one-on-one personalized sessions put me at ease since the gym has never been my friend. In the 4 months that I have trained with CustomFIT I have successfully lost and kept off 27 pounds."
	        )
	      ),
	      _react2.default.createElement(
	        _Client2.default,
	        {
	          name: 'Sierra',
	          image: _sierra2.default,
	          id: 'sierra' },
	        _react2.default.createElement(
	          "p",
	          null,
	          "I began working out with Jerron when he started training at 24 Hour Fitness in December of 2016. I weight 187 pounds and had a BMI(body mass index of 29%. While training with Jerron I lost 20 pounds in 3 months time and 7% in body fat through his training and using his meal prep items. He creates a fun environment and has a unique approach to personal training!"
	        )
	      )
	    )
	  );
	};
	// import menu from '../scripts/menu.js';
	

	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-testimonials-js-af251e89b68af08d62de.js